import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import Button from './Button';
export default function PopupNotify({ title = '', text = '', style = null, buttons = [], className = '' }) {
    return _jsxs(Container, { className: `${className} ui-notify-popup`, style: style !== null && style !== void 0 ? style : {}, children: [_jsxs(Block, { children: [_jsx("header", { children: title }), _jsx("span", { children: text }), buttons && buttons.length > 0 && _jsx("nav", { children: buttons.map((item, i) => _jsx(Button, { color: item.color, onClick: item.onClick, children: item.title }, i)) })] }), _jsx(Triangle, {})] });
}
const Container = styled.div `
  position: absolute;
  bottom: 2.75rem;
  width: 410px;
  color: var(--text-primary);
`;
const Block = styled.div `
    background: var(--accent-blue);
    border-radius: 6px;
    padding: 1.5rem;

    & > header {
        display: flex;
        justify-content: space-between;
        font-size: 1.125rem;
        margin-bottom: 0.675rem;

        svg {
            fill: white;
        }
    }

    & > span {
        font-size: 0.875rem;
        line-height: 1.25rem;
    }

    & > nav {
        margin-top: 0.875rem;

        & > *:not(:first-child) {
            margin-left: 0.5rem;
        }
    }
`;
const Triangle = styled.div `
    width: 0;
    margin: 0 auto;
    border: 8px solid transparent; /* Прозрачные границы */
    border-top: 8px solid var(--accent-blue); /* Добавляем треугольник */
`;
